import type { VideoJsPlayer } from 'video.js';
import type videojs from 'video.js';

import type { AudioTrack } from '../../language-menu/language-menu.types';

import { useEffect, useState } from 'react';

import { VideoJsNativeEvent } from '../videojs-event';

export function useAudioTracks(player: VideoJsPlayer): AudioTrack[] {
  const [audioTracks, setAudioTracks] = useState<AudioTrack[]>([]);

  useEffect(() => {
    let audioTrackList: videojs.AudioTrackList;

    const onAddTrack: videojs.EventTarget.EventListener = (event) => {
      // Default audio tracks have empty language
      if (event?.track?.language === '') {
        return;
      }

      if (event?.track) {
        const track: AudioTrack = {
          id: event.track.id,
          label: event.track.label,
          kind: event.track.kind,
          enabled: event.track.enabled,
          language: event.track.language,
        };
        setAudioTracks((prevState) => [...prevState, track]);
      }
    };

    const onLoadSource = () => {
      // Reset audio tracks
      setAudioTracks([]);
      audioTrackList?.removeEventListener(VideoJsNativeEvent.ADD_TRACK, onAddTrack);

      audioTrackList = player.audioTracks();
      audioTrackList?.addEventListener(VideoJsNativeEvent.ADD_TRACK, onAddTrack);
    };
    player.on(VideoJsNativeEvent.LOAD_START, onLoadSource);

    return () => {
      audioTrackList?.removeEventListener(VideoJsNativeEvent.ADD_TRACK, onAddTrack);
      player.off(VideoJsNativeEvent.LOAD_START, onLoadSource);
    };
  }, [player]);

  return audioTracks;
}
